import React, { useState, useEffect} from 'react';
import serviceForm from './serviceForm.module.css';
import { API_BASE_URL } from '../../constants';
import { axiosAuthFetch } from '../../helpers/apiActions/authFetch';
import Loader from '../loader';
import { getServiceFormByProductId } from '../../hooks/serviceForms';
// import CustomAlert from '../customAlert';

export default function ServiceForm({ product }) {

    const [isLoading, setIsLoading] = useState(false);
    const [checks, setChecks] = useState([{id: 1, description: '', category: ''}]);
    const [serviceFormExists, setServiceFormExists] = useState(false);
    const [serviceFormId, setServiceFormId] = useState(null);
    const [categories, setCategories] = useState([{id: 1, name: ''}]);
    const [newCategoryName, setNewCategoryName] = useState('');
    const [visualChecked, setVisualChecked] = useState(false);


    useEffect(() => {
        async function fetchData() {
            try {
                const serviceFormData = await getServiceFormByProductId(product.id);
                console.log(serviceFormData);
                if(serviceFormData && serviceFormData.serviceForms.data.length > 0) {
                    setVisualChecked(serviceFormData.serviceForms.data[0].attributes.visual_check);
                    const existingServiceForm = serviceFormData.serviceForms.data[0].id;
                    const existingChecks = serviceFormData.serviceForms.data[0].attributes.service_checks.data;
                    // setChecks(existingChecks.map(check => ({
                    //     id: check.id,
                    //     description: check.attributes.description,
                    //     category: check.attributes.category
                    // })));
                    const checksData = existingChecks.map(check => ({
                        id: check.id,
                        description: check.attributes.description,
                        category: check.attributes.category
                    }));
                    const uniqueCategories = Array.from(new Set(checksData.map(check => check.category)));

                    // Oppdater kategoriene
                    setCategories(uniqueCategories.map((category, index) => ({
                        id: index + 1, // Bruk indeks for ID
                        name: category
                    })));

                    setChecks(checksData);
                    
                    setServiceFormExists(true);
                    setServiceFormId(existingServiceForm);
                }
                setIsLoading(false);
            } catch(error) {
                console.error(error)
                setIsLoading(false);
            }
        }
        fetchData()
    }, [product.id]);

    const handleAddCheck = () => {
        const newCheckId = checks.length + 1;
        setChecks([...checks, {id: newCheckId, description: '', category: '' }]);
    };


    const handleCheckDescriptionChange = (id, description) => {
        setChecks(prevChecks => {
            const updatedChecks = prevChecks.map(check =>
                check.id === id ? { ...check, description } : check
            );
            return updatedChecks;
        });
    };

    const handleAddCategory = () => {
        if (newCategoryName.trim() !== '') {
            const newCategoryId = categories.length + 1;
            setCategories([...categories, {id: newCategoryId, name: newCategoryName.trim() }]);
            setNewCategoryName(''); // Nullstill input-feltet etter at kategorien er lagt til
        }
    };

    const handleCategoryNameChange = (e) => {
        setNewCategoryName(e.target.value);
    };
    
    const handleCheckCategoryChange = (id, category) => {
        setChecks(prevChecks => {
            const updatedChecks = prevChecks.map(check =>
                check.id === id ? { ...check, category } : check
            );
            return updatedChecks;
        });
    };

    const handleRemoveCheck = (id) => {
        const updatedChecks = checks.filter(check => check.id !== id);
        setChecks(updatedChecks);
    };

    const createCheck = async (description, category) => {
        try {
            const response = await axiosAuthFetch(`${API_BASE_URL}/service-checks`,{
                data: {
                description: description,
                category: category,
                }
            },'POST');
            // console.log('Check created:', response.data)
            return response.data.id;
        } catch(error) {
            console.error(error);
        }
    };

    const createServiceForm = async (productID, checkIDs) => {
        try {
            const response = await axiosAuthFetch(`${API_BASE_URL}/service-forms`, {
                data: {
                visual_check: false,
                product: productID,
                service_checks: {
                    connect: checkIDs
                    }
                }
            }, 'POST');
            // console.log(response.data)
            return response.data;
        } catch(error) {
            console.error(error)
        }
    }

    const createVisualServiceForm = async (productID, checkID) => {
        try {
            const response = await axiosAuthFetch(`${API_BASE_URL}/service-forms`, {
                data: {
                product: productID,
                visual_check: true,
                service_checks: {
                    connect: checkID
                    }
                }
            }, 'POST');
            // console.log(response.data)
            return response.data;
        } catch(error) {
            console.error(error)
        }
    }

    const updateServiceForm = async (serviceFormId, productID, checkIDs) => {
        try {
            const response = await axiosAuthFetch(`${API_BASE_URL}/service-forms/${serviceFormId}`, {
                data: {
                    product: productID,
                    service_checks: {
                        set: checkIDs
                    },
                }
            }, 'PUT');
            return response.data;
        } catch (error) {
            console.error(error);
        }
    }

    const createServiceAction = async (checkID, formID) => {
        try {
            const response = await axiosAuthFetch(`${API_BASE_URL}/service-actions`, {
                data: {
                    completed: false,
                    service_check: {
                        connect: [checkID]
                    },
                    service_form: {
                        connect: [formID]
                    }
                }
            }, 'POST');
            // console.log(response.data);
            return response.data.id;
        } catch(error) {
            console.error(error);
            return null;
        }
    };

    const handleSubmit = async () => {
        setIsLoading(true);
        try {
            if (visualChecked) {
                // Custom logic when visualChecked is true
                console.log('Custom logic for visual check only');

                const visualID = [119];

                const createdServiceForm = await createVisualServiceForm(product.id, visualID);
                const serviceFormId = createdServiceForm.id;
                const serviceActionComplete = await createServiceAction(119, serviceFormId)
                    // Opprett serviceActions og koble dem til serviceForms og serviceChecks
                console.log(serviceActionComplete);

                // ID 117 for visuell sjekk så da trengs vel bare å lage action og connecte til form?




                // Add your custom submit logic here
            } else {
                // Existing logic when visualChecked is false
                const checkIDs = [];

                // Opprett alle sjekker (service_checks) og lagre deres ID-er
                for (const check of checks) {
                    try {
                        const checkID = await createCheck(check.description, check.category);
                        checkIDs.push(checkID);
                    } catch (error) {
                        console.error(error);
                    }
                }

                // Opprett serviceForm og serviceActions
                if (serviceFormExists) {
                    await updateServiceForm(serviceFormId, product.id, checkIDs);

                    for (const checkID of checkIDs) {
                        try {
                            await createServiceAction(checkID, serviceFormId);
                        } catch (error) {
                            console.error(error);
                        }
                    }
                } else {
                    const createdServiceForm = await createServiceForm(product.id, checkIDs);
                    const serviceFormId = createdServiceForm.id;

                    // Opprett serviceActions og koble dem til serviceForms og serviceChecks
                    for (const checkID of checkIDs) {
                        try {
                            await createServiceAction(checkID, serviceFormId);
                        } catch (error) {
                            console.error(error);
                        }
                    }
                }

                console.log('service form opprettet');
            }
            setIsLoading(false);
            alert('Serviceskjema opprettet!');
            window.location.reload();
        } catch (error) {
            console.error(error);
            setIsLoading(false);
        }
    };

    const handleCheck = () => {
        setVisualChecked(!visualChecked);
    }


    if(isLoading) {
        return ( <Loader /> )
    }

    return(
            <div className={serviceForm.container1}>
                <div className={serviceForm.container7}>
                    <div className={serviceForm.visuellSjekk}>
                        Visuell sjekk
                    </div>
                    <div className={`${serviceForm.visuellSjekkButton} ${visualChecked ? serviceForm.checked : ''}`} onClick={handleCheck}>
                        <div className={serviceForm.running}></div>
                    </div>
                </div>
                {!visualChecked && (
                <>
                    <div className={serviceForm.categoryButtonDiv}>
                        <label>Kategori / underoverskrift</label>
                        <div className={serviceForm.container5}>
                            <input
                                type="text"
                                value={newCategoryName}
                                onChange={handleCategoryNameChange}
                                placeholder="Skriv inn kategorinavn"
                            />
                            <button className={`${serviceForm.addButton}`} onClick={handleAddCategory}>
                                Legg til Kategori
                            </button>
                        </div>
                    </div>
                    {checks.map((check, index) => (
                        <div className={serviceForm.container2} key={`${check.id}-${index}`}>
                            <label>Sjekk nummer {index + 1}</label>
                            <div className={serviceForm.container3}>
                                <input
                                    className={serviceForm.input}
                                    type="text"
                                    value={check.description}
                                    onChange={e => handleCheckDescriptionChange(check.id, e.target.value)}
                                />
                                <button className={serviceForm.removeButton} onClick={() => handleRemoveCheck(check.id)}>
                                    Fjern
                                </button>
                                <div className={serviceForm.container6}>
                                    <select
                                        value={check.category}
                                        onChange={e => handleCheckCategoryChange(check.id, e.target.value)}
                                    >
                                        <option value="">Velg kategori</option>
                                        {categories.map(category => (
                                            <option key={category.id} value={category.name}>
                                                {category.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                    ))}
                    <button className={serviceForm.addButton} onClick={handleAddCheck}>
                        Legg til sjekk
                    </button>
                </>
            )}
                <div className={serviceForm.container4}>
                    <button className={serviceForm.submitButton} onClick={handleSubmit}>Send</button>
                </div>
            </div>
        );
}